import {
  dimensiondata_1_tetelek_group_w200_row,
  gigawatt_ora_value_1_data_precision,
  year_column_expanded,
  month_row,
  month_column,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const haviBruttoVillanyConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/HaviBruttoVillany',
      select: ['date', 'dimension_1', 'value_1'],
      orderby: [Date],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_tetelek_group_w200_row,
      year_column_expanded,
      month_column,
      gigawatt_ora_value_1_data_precision,
      order_1,
      order_2
    ],
  },
};
